import React from 'react';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useForm, FormProvider } from 'react-hook-form';
import { FormTextField } from '@personal-dashboard/ui';

interface CreateSectionFormProps {
  onCreate: (title: string) => void;
}

interface FormValues {
  title: string;
}

export const CreateSectionForm: React.FC<CreateSectionFormProps> = ({ onCreate }) => {
  const methods = useForm<FormValues>({ defaultValues: { title: '' } });
  const { handleSubmit, reset } = methods;

  const onSubmit = (data: FormValues) => {
    if (!data.title.trim()) return;
    onCreate(data.title.trim());
    reset({ title: '' });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 4 }}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: 8, flexGrow: 1 }}>
          <FormTextField
            name="title"
            size="small"
            fullWidth
            placeholder="New Section Title (e.g., Nutrition Stats)"
          />
          <Button type="submit" variant="contained" startIcon={<AddIcon />}>
            Create Section
          </Button>
        </form>
      </FormProvider>
    </Box>
  );
};

export default CreateSectionForm;
